module.exports = __webpack_public_path__ + "img/修改头像.0e3cf1e4.png";